var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home mt-65"},[_c('search-bar'),_c('customer-vehicle-status'),_c('admin-vehicle-status')],1)}
var staticRenderFns = []

export { render, staticRenderFns }